// Library Import
import { Flex, useBoolean, Text } from "@chakra-ui/react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../../components/Navbar";

// Icon Imports

// Local Imports

const TestScreen = () => {
  const { challengeId } = useParams();
  const navigate = useNavigate();

  const [mobileMode, setMobileMode] = useBoolean();

  const { userToken } = useSelector((state) => state.stateUserReducer);

  useEffect(() => {
    if (window.innerWidth < 450) {
      setMobileMode.on();
    } else {
      setMobileMode.off();
    }

    if (!userToken) {
      navigate("/");
    }
  }, [window.innerWidth, userToken]);

  return (
    <>
      {mobileMode ? (
        <Flex
          height="100vh"
          width="100ww"
          justifyContent="center"
          alignItems="center"
          px="3px"
        >
          <Text fontSize="18px">This page will not open in mobile screen</Text>
        </Flex>
      ) : (
        <Flex height="100vh" width="100vw" direction={"column"}>
          <Navbar active={"TestScreen"} />
          <iframe
            title="challenge"
            height="100%"
            width="100%"
            src={`https://onecompiler.com/embed/challenges/${challengeId}/two-sum?theme=light&hideNew=true&apiKey=${
              import.meta.env.VITE_ONECOMPILER_ALTAPI
            }&userApiToken=${
              userToken?.token
            }&allow="clipboard-read *; clipboard-write *; camera; display-capture; microphone"`}
          ></iframe>
        </Flex>
      )}
    </>
  );
};

export default TestScreen;
